import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ManageComponentsService } from '../../manage-components/manage-components.service';
import { SetupModelsService } from '../setup-models.service';
import { DispalyMultiselect, Family } from '../../../entities';
import { ModelSetupVM, ServiceCycleVM, Industry, ModelBaseObservations, ChainInfoModel, PartlineModel } from '../setup-models.model';
//import { MatDialog, MatFormField, MatTableDataSource } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { AppService } from '../../../app.service';
import { NotificationsService } from 'angular2-notifications';
import { Make, MakeViewModel, Model, UpdateComponentSproket } from '../../manage-components/manage-components.model';
import { PreferencesService } from '../../preferences/preferences.service';
import { Router } from '@angular/router';
import { FavouriteDialogService } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog.service';
import { ModelSelectionFilter } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog-modal';
import { GenericIdName } from '../../GET_NEW_UI/setup-implement/setup-implement.model';
//import { MatTableDataSource } from '@angular/material/table';
import { ObspointsUpdateLimitsComponent } from '../obspoints-update-limits/obspoints-update-limits.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
//import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-search-container',
  templateUrl: './search-container.component.html',
  styleUrls: ['./search-container.component.scss'],
  providers: [ManageComponentsService]
})

export class SearchContainerComponent implements OnInit {
  model_auto_: number = 0;
  make_auto_: number = 0;
  type_auto_: number = 0;
  displayedColumns = ['modeldesc', 'typedesc', 'makedesc'];
  familyList: Family[] = []
  MakeList: Make[] = [];
  filteredMakeList: Make[] = [];
  MakeViewModel: MakeViewModel[] = [];
  filteredMakeViewModel: MakeViewModel[] = [];
  filteredMakeViewModelMain: MakeViewModel[] = [];
  serviceCycleList: ServiceCycleVM[] = []
  serviceCycleListFilter: ServiceCycleVM[] = []
  baseModelList: ServiceCycleVM[] = []
  eqIndustryList: Industry[] = []
  eqIndustryListMain: Industry[] = []
  partLineList: PartlineModel[] = []

  eqIndustryListFilter: Industry[] = []
  dataSource_ = new MatTableDataSource();
  displayedColumns_ = ['chain','comparttype', 'compartid', 'compart', 'makedesc', 'compart_note'];
  //serach variable
  modelDisabled: boolean = false
  modelGridList: ModelSetupVM[]
  selectRowDetails
  // dataSource = new MatTableDataSource();
  dataSource = new MatTableDataSource<ModelSetupVM>([]);
  //loading
  showTableView: boolean = false
  showTableCOmponentView: boolean = false
  showTableChainView: boolean = false
  showSearchLoader: boolean = false;
  tableDataLoading: boolean = false
  newRowSelected: boolean = false
  modelTitle: string;
  //rowdata
  model_auto: number=0
  make_auto: number
  type_auto: number
  service_cycle_type_auto: number
  equip_reg_industry_auto: number
  BaseModelId: number

  typeid: string
  typedesc: string
  makeid: string
  makedesc: string
  modelid: string
  modeldesc: string
  created_date: string
  created_user: string
  modified_date: string
  modified_user: string
  ModelNote: string
  ModelImage: string
  ModelImageLeft: string
  ModelImageRight: string
  IsRightImageRotate:boolean;
  service_cycle_type: string
  s_cycle_type_description: string
  industry_name: string
  industry_name_new: string;
  userName: string

  selectedFile: File;
  ModelImage_fromPC: string

  isNew: boolean = true
  newRow: boolean = false

  filteredModels: Model[] = [];
  ModelList: Model[] = [];
  ModelAutoCompleteText: string = "";
  uploadToMobile: boolean = false;
  industryTitle: string;
  defaultCycle: string;
  observationLists: ModelBaseObservations[];
  defaultInspectionCycleTitle: string;
  UCConditionDisplayOption: number;
  familytitle: string;
  makeTitle: string;

  chainDescription: string;
  serialNumberstart: string;
  serialNumberEnd: string;

  pitch: number;
  noOfLinks: number;
  linkHeight: number;
  numberOfIdlers: number;
  boltHoleDiameter: number;
  bushingOD: number;
  numberOfCarrierRollers: number;
  chainInsideSpread: string;
  chainOutsideSpread: string;
  numberOfTrackRollers: number;
  chainHardwareDescription: string;
  bercoPartNumber: string;
  casePartnumber: string;
  quantity: number;
  partLineId: number;
  cost: number;
  chainSectionShow:boolean;

  displayedColumnsChain = ['chaindesc', 'startsrno', 'endsrno', 'pitch', 'noOflinks'];

  constructor(
    public _componentService: ManageComponentsService,
    public _modelService: SetupModelsService,
    private _sanitizer: DomSanitizer,
    private _appService: AppService,
    private _notify: NotificationsService,
    private readonly _pref: PreferencesService,
    private _router: Router,
    private _favouriteDialogService: FavouriteDialogService,
    private _dialog: MatDialog,
  ) { }


  ngOnInit() {
    
    
    this.loadFamilyList();
    this.loadAllMakeList()
    this.loadAllMakeListForAddEdit();
    this.loadModelList();
    this.loadEqIndustryList();
    this.loadServiceCycleList();
    this.loadBaseModelList();
    this.loadPartLineList();
    this._appService.GetLoggedInUserName().subscribe(result => {
      this.userName = result
    });
  }



  loadFamilyList() {
    this._modelService.getFamilyList().subscribe(result => {
      this.familyList = result;
      this._dropDownFamilyFiltered = result;
      this._dropDownFamilyFilteredMain = result;
      this._dropDownFamilyFiltered1 = [];
      this.familyList.forEach(element => {
        this._dropDownFamilyFiltered1.push({display: element.Title,Value:element.Id.toString()})
      });
    })
  }

  loadAllModelsList() {
    this._componentService.getModelListV2().subscribe(result => {
      this.ModelList = result;
      this.filteredModels = result;
    })
  }
 
 
  loadAllMakeList() {
    this._componentService.GetMakeFromFamily(this.type_auto_).subscribe(result => {
      this.MakeViewModel = result;
      this.filteredMakeViewModel = result;
      //this.filteredMakeViewModelMain = result;

    })
  }

  loadAllMakeListForAddEdit() {
    this._componentService.GetMakeFromFamily(this.type_auto_).subscribe(result => {
      this.MakeViewModel = result;
      this.filteredMakeViewModelMain = result;
    })
  }


  @ViewChild('autoCompleteInput', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger: MatAutocompleteTrigger;
  @ViewChild('autoCompleteInput1', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger1: MatAutocompleteTrigger;
  @ViewChild('autoCompleteInput2', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger2: MatAutocompleteTrigger;
  @ViewChild('autoCompleteInput3', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger3: MatAutocompleteTrigger;
  @ViewChild('autoCompleteInput4', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger4: MatAutocompleteTrigger;
  @ViewChild('autoCompleteInput5', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger5: MatAutocompleteTrigger;
  @ViewChild('autoCompleteInput6', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger6: MatAutocompleteTrigger;
chainCreateSection:boolean=false;

  resetFields() {
    this.service_cycle_type = null;
    this.industry_name_new = null;
    this.showTableView = false;
    this.isNew = true;
    this.modelid = ""
    this.modeldesc = ""
    this.make_auto = null;
    // this.type_auto = null;
    this.model_auto = 0;
    this.equip_reg_industry_auto = 0;
    this.BaseModelId = 0;
    this.service_cycle_type_auto = 0;
    this.ModelNote = ""
    this.ModelImage = ""
    this.dataSource.data = null
    this.dataSource_.data = null
    this.compTypeList = []
    this.type_auto_ = 0;
    this.model_auto_ = 0;
    this.make_auto_ = 0;
    this.modelDisabled = false
    this.newRow = false;

    this.familyId = 0;
    this.makeid = '';
    this.autoCompleteTrigger.closePanel();
    this.autoCompleteTrigger.writeValue('');
    this.autoCompleteTrigger1.closePanel();
    this.autoCompleteTrigger1.writeValue('');
    this.autoCompleteTrigger2.closePanel();
    this.autoCompleteTrigger2.writeValue('');
    this.autoCompleteTrigger3.closePanel();
    this.autoCompleteTrigger3.writeValue('');
    this.autoCompleteTrigger4.closePanel();
    this.autoCompleteTrigger4.writeValue('');
    this.autoCompleteTrigger5.closePanel();
    this.autoCompleteTrigger5.writeValue('');
    this.autoCompleteTrigger6.closePanel();
    this.autoCompleteTrigger6.writeValue('');
    this.uploadToMobile = false;
    this.filteredMakeViewModel = null;
    this.typedesc = null;
    this.makedesc = null;
    this.componentChecked = false;
    this.ResetChainFileds();
    this.loadFamilyList();
    this.loadAllMakeList();
    this.loadAllMakeListForAddEdit();
    this.chainSectionShow=false;
    this.filteredMakeViewModel = null;
    this._componentService.getModelListV2().subscribe(result => {
      this.ModelList = result
      this.filteredModels = result
    });

  }

  filerModelList: GenericIdName[];
modalLoding:boolean=false
  
loadModelList() {
    this.modalLoding=true;
    this.filteredModels = null

    let makeArray = [];
  let familyArray = [];
  if (this.type_auto_ > 0)
    familyArray.push(this.type_auto_);
  if (this.make_auto_ > 0)
    makeArray.push(this.make_auto_);

    var params: ModelSelectionFilter = {
      Families: familyArray,
      Makes: makeArray
    }
    this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
      if (r) {
        this.filerModelList = r;
        this.ModelList = this.filerModelList.map(model => ({ Id: model.Id, Title: model.Name }));
        this.filteredModels = this.ModelList;
       
      }
      this.modalLoding=false;
    });

  }
  familyId: number = 0;

  // onSelectFamily(event: any) {
  //   let id = this._dropDownFamilyFiltered.find(f => f.Title == event.value.split('|')[0].trim()).Id;
  //   this.familyId = id;

  //   this.familyTitle = this._dropDownFamilyFiltered.find(f => f.Title == event.value.split('|')[0].trim()).Title + ' | ' + this._dropDownFamilyFiltered.find(f => f.Title == event.value.split('|')[0].trim()).Symbol
  //   this.loadAllMakeList();
  //   this.autoCompleteTrigger1.closePanel();
  //   this.autoCompleteTrigger1.writeValue('');
  // }

  // onSelectFamilyMain(event: any) {
  //   let id = this._dropDownFamilyFiltered.find(f => f.Title == event.value).Id;
  //   this.typedesc = this._dropDownFamilyFiltered.find(f => f.Title == event.value).Title;
  //   this.familyId = id;
  //   this.type_auto = id;

  //   this.loadAllMakeList();
  //   this.autoCompleteTrigger5.closePanel();
  //   this.autoCompleteTrigger5.writeValue('');
  //   this.loadBaseModelList();
  // }

  onSelectFamily(event: any) {
    let id = this._dropDownFamilyFiltered.find(f => f.Title == event.value.split('|')[0].trim()).Id;
    this.type_auto_ = id;
    //console.log("event:", event.value);
    this.familyTitle = this._dropDownFamilyFiltered.find(f => f.Title == event.value.split('|')[0].trim()).Title + ' | ' + this._dropDownFamilyFiltered.find(f => f.Title == event.value.split('|')[0].trim()).Symbol
    this.loadAllMakeList();
    this.autoCompleteTrigger1.closePanel();
    this.autoCompleteTrigger1.writeValue('');
    //console.log("familyTitle", this.familyTitle);
    //console.log("makeTitle", this.makeTitle);
    //console.log("modelTitle", this.modelTitle);
  }

  onSelectFamilyMain(event: any) {
    let id = this._dropDownFamilyFiltered.find(f => f.Title == event.value).Id;
    this.typedesc = this._dropDownFamilyFiltered.find(f => f.Title == event.value).Title;
    this.familyId = id;
    this.type_auto = id;
    // this.loadAllMakeListForAddEdit();
    this.autoCompleteTrigger5.closePanel();
    this.autoCompleteTrigger5.writeValue('');
    this.loadBaseModelList();
  }

  loadModelListGrid() {
    this.tableDataLoading = true;
    this.showTableView=false;
    this.dataSource.data=[];
    
    if ((this.type_auto_ == 0 || this.type_auto_ == undefined) && (this.make_auto_ == 0 || this.make_auto_ == undefined) && (this.model_auto_ == 0 || this.model_auto_ == undefined)) {
      this._notify.warn('Info', 'Please select atleast one option for search!.');
      this.tableDataLoading = false;
    } else {

      this._modelService.getModedlDetailsInfo(this.make_auto_, this.model_auto_, this.type_auto_).subscribe(result => {
        console.log("Frid result:", result);
        if (result != null) {
          if(result.length>0){
            this.dataSource.data = result;
            this.showTableView=true;
            this.tableDataLoading = false;
          }else{
            this.showTableView=true;
          this.tableDataLoading = false;
          }
        }else{
          this.showTableView=true;
         
       this.tableDataLoading = false;
         
        }
        //if(this.model_auto>0){
        //  this.loadChainInfo(this.model_auto);
        //}
      })
    }
  }

  loadServiceCycleList() {
    this._modelService.getServiceCycleList().subscribe(result => {
      this.serviceCycleList = result;
      this.serviceCycleListFilter = result;
    })
  }

  loadBaseModelList() {
    this._modelService.getBaseModelList(this.familyId).subscribe(result => {
      this.baseModelList = result;
    })
  }

  loadPartLineList() {
    this._modelService.GetPartLine().subscribe(result => {
      this.partLineList = result;
    })
  }

  loadEqIndustryList() {
    this._modelService.getEquipIndustryist().subscribe(result => {
      this.eqIndustryList = result;
      this.eqIndustryListFilter = result;
    })
  }

  selectRow(row) {
    this.selectRowDetails = row;
    this.newRowSelected = true
    this.modelid = row.modelid
    this.modeldesc = row.modeldesc
    this.make_auto = row.make_auto
    this.makeid = row.makeid
    this.makedesc = row.makedesc
    this.familyId = row.type_auto
    this.type_auto = row.type_auto
    this.typedesc = row.typedesc + " | " + row.typeid
    this.typeid = row.typeid
    this.equip_reg_industry_auto = row.equip_reg_industry_auto
    this.BaseModelId = row.basemodelid
    this.industry_name_new = this.eqIndustryList.find(x => x.Id === row.equip_reg_industry_auto).Title
    this.service_cycle_type = this.serviceCycleList.find(x => x.Id === row.service_cycle_type_auto).Title
    this.service_cycle_type_auto = row.service_cycle_type_auto
    this.ModelImage = row.ModelImage
    this.ModelImageLeft = row.ModelImageLeft
    this.ModelImageRight = row.ModelImageRight
     this.IsRightImageRotate = row.IsRightImageRotate
    this.ModelNote = row.ModelNote
    this.model_auto = row.model_auto
    this.isNew = false;
    this.newRow = false;
    this.IsURLR=false;
    this.IsURLL=false;
    this.uploadToMobile = row.uploadToMobile;
    this.loadChainInfo(this.model_auto);
    this.chainSectionShow = true;
  }

  modelselect(modelid) {

    this.model_auto = this.filteredModels.find(f => f.Title == modelid).Id
  
    if (this.model_auto > 0) {
      this.modelDisabled = true
    }
    else
      this.modelDisabled = false
  }

  sanitize(image: string) {

    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);

  }


  compTypeList
  componentType_ = []
  compartid: string
  compart_auto: number
  defaultTypeList = []
  newArr = []
  componentChecked: boolean;
  
  componentDetailCheck(event:any) {

    if(event.checked){
      this.newRow = true;
      this.loadComponentInfo();
    }else{
      this.newRow = false;
    }
    

  }
  loadComponentInfo() {

    this._modelService.getComponentTypeList().subscribe(r => {
      let defaultTypeList = r;

      this.componentType_ = []
      this.newArr = []
      this.newRow = true
      this.tableDataLoading = true
      this._modelService.getComponentInfoByModelId(this.model_auto, this.chainAutoID).subscribe(result => {
        this.dataSource_.data = result
        this.compTypeList = result

        if (this.compTypeList.length > 0) {
          for (let i = 0; this.compTypeList.length > i; i++) {
            this.compTypeList.map(m => {
              let Typeid = m.comparttype
              if (this.componentType_.find(x => x.Typeid == Typeid)) {
              }
              else {

                this.componentType_.push({ Typeid: Typeid, Order: 1 })

              }

            });
          }
        }


        var temparr1 = []

        for (var i = 0; i < defaultTypeList.length; i++) {
          temparr1[defaultTypeList[i].Typeid] = true;
        }

        for (var i = 0; i < this.componentType_.length; i++) {
          if (temparr1[this.componentType_[i].Typeid]) {
            delete temparr1[this.componentType_[i].Typeid];
          } else {
            temparr1[this.componentType_[i].Typeid] = true;
          }
        }

        for (var k in temparr1) {
          this.newArr.push({ Typeid: k, Order: 0 });
        }

        Array.prototype.push.apply(this.componentType_, this.newArr);

        this.showTableCOmponentView = true
        this.tableDataLoading = false

      })

      this._modelService.getObservationInfoByModelId(this.model_auto).subscribe(res => {

        this.observationLists = res
      });

      this._modelService.getMobileScreenDisplayOfObservationsModelOption(this.model_auto).subscribe(result => {

        this.UCConditionDisplayOption = result;

      });

    })


  }

  onSelectPhoto(event: any, ImageFlag:number) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFile = event.target.files[0];
      reader.onloadend = (e) => {
        this.uploadPhoto(reader.result as string,ImageFlag);

      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }
IsURLL:boolean=false;
IsURLR:boolean=false;
  uploadPhoto(newPhoto: string,ImageFlag:number) {
    if(ImageFlag==1){
      this.ModelImage_fromPC = newPhoto.split(",")[1];
    this.ModelImage = this.ModelImage_fromPC;
    }
    else if(ImageFlag==2){
      this.ModelImageLeft = newPhoto.split(",")[1];
      this.IsURLL=true;
    }else if(ImageFlag==3){
      this.ModelImageRight = newPhoto.split(",")[1];
      this.IsURLR=true;
    }

  }



  response

  saveUpdateSetupModel() {
    if(this.modelid.trim().length!=0){
      if(this.modeldesc.trim().length!=0){
        if(this.type_auto>0){
          if(this.make_auto>=0){
            // if(this.ModelImage.trim().length!=0){
              this._modelService.saveSetupModeltDetails(this.model_auto, this.make_auto, this.type_auto, this.service_cycle_type_auto, this.equip_reg_industry_auto, this.modelid, this.modeldesc,
                this.created_date, this.userName, this.modified_date, this.userName, this.ModelNote, this.ModelImage, this.uploadToMobile, this.BaseModelId, this.ModelImageLeft, this.ModelImageRight)
                .subscribe(result => {
                  this.response = result
                  if (this.response.Id < 0) {
                    this._notify.error(this.response.Message)
                  }
                  else {
                    this._notify.success('Saved', ' Model Details');
                    //this.resetFields();
                    this._componentService.getModelList();
                  }
                })
            // }else{
            //   this._notify.warn('Info', 'Make field is required.');
            // }
          }else{
            this._notify.warn('Info', 'Make field is required.');
          }
        }else{
          this._notify.warn('Info', 'Family field is required.');
        }
      }else{
        this._notify.warn('Info', 'Model description field is required.');
      }
    }else{
      this._notify.warn('Info', 'ModelID field is required.');
    }
    
  }

  deleteSetupModel() {
    this._modelService.deleteSetupModel(this.model_auto).subscribe(result => {
      this.response = result
      if (this.response.Id <= 0) {
        this._notify.error(this.response.Message)
      }
      else {
        this._notify.success('Deleted', ' Model Details');
        this.resetFields();
        this._componentService.getModelList();

      }
    })

  }
  selectRowDetails_
  selectRowChain1;
  selectedRow(row) {
    this.selectRowDetails_ = row;
    this.compart_auto = row.compartid_auto;
    this.compartid = row.compartid
    // window.open('/setup-component/' + this.compartid, '_blank');

    this._pref.GetReplaceExistingTabStatus().subscribe(res => {
      if (res == "True") {
        this._router.navigate(['/setup-component', this.compartid]);
      } else {
        window.open('/setup-component/' + this.compartid, '_blank');

      }
    });
  }

  toggleUCConditions(event: any) {
    this._modelService.setMobileScreenDisplayOfObservationsModelOption(this.model_auto, event.value).subscribe(result => {
      if (result) {
        if (event.value == "2")
          this.EnableObservationsPoints();
        this._notify.success('Update', ' Observation option updated for selected model.');
      } else {
        this._notify.error('Error', ' Error while updating observation option!');
      }
    });
  }

  EnableObservationsPoints() {
    this._modelService.EnableObservationsByModelId(this.model_auto).subscribe(result => {
      this.observationLists = result
    });
  }

  UpdateVisibilityForObservation(Id: number) {

    this._modelService.UpdateVisibilityOnObs(Id).subscribe(result => {

      if (result) {

        this._modelService.getObservationInfoByModelId(this.model_auto).subscribe(res => {

          this.observationLists = res
        });
      }
    });
  }

  EditLimits(obs: ModelBaseObservations) {
    let update = this._dialog.open(ObspointsUpdateLimitsComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        observationInfo: obs,
      }
    });

    update.afterClosed().subscribe(createPop => {
      if (createPop == undefined)
        return;
      if (createPop) {
        this._modelService.getObservationInfoByModelId(this.model_auto).subscribe(res => {
          this.observationLists = res
          this._notify.success("Update Sucessfully")
        });
      }
    });

  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  _dropDownFamilyFiltered: Family[];
  _dropDownFamilyFilteredMain: Family[];
  _dropDownFamilyFiltered1: DispalyMultiselect[];

  // familyChanged(event: any) {
  //   if (event.target.value != "") {
  //       const filterValue = event.target.value.toLowerCase();
  //       this._dropDownFamilyFiltered = this.familyList.filter(option => option.Title.toLowerCase().includes(filterValue));
  //   } else {
  //     this.familyId = 0;
  //     this.autoCompleteTrigger1.closePanel();
  //     this.autoCompleteTrigger1.writeValue('');
  //     this.autoCompleteTrigger2.closePanel();
  //     this.autoCompleteTrigger2.writeValue('');
  //     this.dataSource = null;
  //     this.showTableView = false;
  //     this.loadFamilyList();
  //     this.loadAllMakeList();
  //     this.loadAllModelsList();
  //     this.make_auto = 0;
  //     this.model_auto = 0;
  //   }

  // }


  // familyChangedMain(event: any) {
  //   if (event.target.value != "") {
      
  //       const filterValue = event.target.value.toLowerCase();
  //       this._dropDownFamilyFilteredMain = this.familyList.filter(option => option.Title.toLowerCase().includes(filterValue));
     

  //   } else {
  //     this.autoCompleteTrigger5.closePanel();
  //     this.autoCompleteTrigger5.writeValue('');
  //   }

  // }


  // MakeChanged(event: any) {
  //   if (event.target.value != "") {
      
  //       const filterValue = event.target.value.toLowerCase();
  //       this.filteredMakeViewModel = this.MakeViewModel.filter(option => option.Makedesc.toLowerCase().includes(filterValue));
      
  //   } else {
  //     this.make_auto = null;
  //     if (this.familyId != 0) {
  //       this.loadAllMakeList();
  //     }
  //   }
  // }

  // MakeChangedMain(event: any) {
  //   if (event.target.value != "") {
     
  //       const filterValue = event.target.value.toLowerCase();
  //       this.filteredMakeViewModelMain = this.MakeViewModel.filter(option => option.Makedesc.toLowerCase().includes(filterValue));
    
  //   } else {
  //     this.make_auto = null;
  //     if (this.familyId != 0) {
  //       this.loadAllMakeList();
  //     }
  //   }
  // }
  // familyTitle: string;

  // onSelectMake(event: any) {
  //   let id = this.filteredMakeViewModel.find(f => f.Makedesc == event.value).Make_auto
  //   this.makeid = id.toString();
  //   this.make_auto = id;
  //   this.loadModelList();
  // }

  // onSelectMakeMain(event: any) {
  //   let id = this.filteredMakeViewModel.find(f => f.Makedesc == event.value).Make_auto
  //   this.makeid = id.toString();
  //   this.make_auto = id;
  // }

  familyChanged(event: any) {
    if (event.target.value != "") {
        const filterValue = event.target.value.toLowerCase();
      this._dropDownFamilyFiltered = this.familyList.filter(option => option.Title.toLowerCase().includes(filterValue));
      this.make_auto_ = 0;
      this.model_auto_ = 0;
      this.modelTitle = "";
      this.makeTitle = "";
    } else {
      this.type_auto_ = 0;
      this.autoCompleteTrigger1.closePanel();
      this.autoCompleteTrigger1.writeValue('');
      this.autoCompleteTrigger2.closePanel();
      this.autoCompleteTrigger2.writeValue('');
      this.dataSource = null;
      this.showTableView = false;
      this.loadFamilyList();
      this.loadAllMakeList();
      this.loadAllModelsList();
      this.make_auto_ = 0;
      this.model_auto_ = 0;
      this.modelTitle = "";
      this.makeTitle = "";
    }

  }


  familyChangedMain(event: any) {
    if (event.target.value != "") {
      
        const filterValue = event.target.value.toLowerCase();
        this._dropDownFamilyFilteredMain = this.familyList.filter(option => option.Title.toLowerCase().includes(filterValue));
     

    } else {
      this.autoCompleteTrigger5.closePanel();
      this.autoCompleteTrigger5.writeValue('');
    }

  }


  MakeChanged(event: any) {
    if (event.target.value != "") {
        const filterValue = event.target.value.toLowerCase();
      this.filteredMakeViewModel = this.MakeViewModel.filter(option => option.Makedesc.toLowerCase().includes(filterValue));
      this.model_auto_ = 0;
      this.modelTitle = "";
      //this.loadModelList();
    } else {
      this.make_auto_ = 0;
      this.model_auto_ = 0;
      this.modelTitle = "";
      this.loadAllMakeList();
      this.loadAllModelsList();
    }
  }

  MakeChangedMain(event: any) {
    if (event.target.value != "") {
     
        const filterValue = event.target.value.toLowerCase();
        this.filteredMakeViewModelMain = this.MakeViewModel.filter(option => option.Makedesc.toLowerCase().includes(filterValue));
    
    } else {
      this.make_auto = null;
      this.loadAllMakeListForAddEdit();
    }
  }
  familyTitle: string;

  onSelectMake(event: any) {
    let id = this.filteredMakeViewModel.find(f => f.Makedesc == event.value).Make_auto
    this.makeTitle = event.value
    //this.makeid = id.toString();
    this.make_auto_ = id;
    //console.log("familyTitle", this.familyTitle);
    //console.log("makeTitle", this.makeTitle);
    //console.log("modelTitle", this.modelTitle);
    this.loadModelList();
  }

  onSelectMakeMain(event: any) {
    let id = this.filteredMakeViewModel.find(f => f.Makedesc == event.value).Make_auto
    this.makeid = id.toString();
    this.make_auto = id;
  }

  industryChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this.eqIndustryListFilter = this.eqIndustryList.filter(option => option.Title.toLowerCase().includes(filterValue));
    }
  }

  onSelectIndustry(event: any) {
    let id = this.eqIndustryListFilter.find(f => f.Title == event.value).Id;
    this.equip_reg_industry_auto = id;

    this.industryTitle = this.eqIndustryListFilter.find(f => f.Title == event.value).Title;
  }

  defaultInspectionCycleChanged(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this.serviceCycleListFilter = this.serviceCycleList.filter(option => option.Title.toLowerCase().includes(filterValue));
    }

  }


  onSelectdefaultInspectionCycle(event: any) {
    let id = this.serviceCycleListFilter.find(f => f.Title == event.value).Id;
    this.service_cycle_type_auto = id;

    this.defaultInspectionCycleTitle = this.serviceCycleListFilter.find(f => f.Title == event.value).Title;
  }
  // changeModelAutoComplete(event){
  //   const filterValue = event.target.value.toLowerCase();
  //   this.filteredModels = this.ModelList.filter(option => option.Title.toLowerCase().includes(filterValue));
  // }

  changeModelAutoComplete(event: any) {
    if (event.target.value != "") {
        const filterValue = event.target.value.toLowerCase();
        this.filteredModels = this.ModelList.filter(option => option.Title.toLowerCase().includes(filterValue));
    } else {
      this.model_auto_ = 0;
      this.loadModelList();
    }
  }

  onModelSelected(event: any) {
    let id = this.filteredModels.find(f => f.Title == event.value).Id;
    this.model_auto_ = id;
    //this.modelid= event.value;
    this.modelTitle = this.filteredModels.find(f => f.Title == event.value).Title;
    this.chainSectionShow=false;
    this.ResetChainFileds();
    // this.loadChainInfo(this.model_auto);
    this.dataSource_=new MatTableDataSource();
    this.componentChecked = false;
    this.newRow = false;
    this.hasChainData=false;
  }

  // setStep(index: number) {
  //   this.step.set(index);
  // }
  saveUpdateSetupChain() {
    if (this.chainDescription.toString().trim().length != 0) {
      if ( this.noOfLinks != null && this.noOfLinks!=0) {
        this._modelService.saveSetupchainDetail(
          this.model_auto,
          this.chainDescription,
          this.serialNumberEnd,
          this.serialNumberstart,
          this.pitch,
          this.noOfLinks,
          this.linkHeight,
          this.numberOfIdlers,
          this.boltHoleDiameter,
          this.bushingOD,
          this.numberOfCarrierRollers,
          this.numberOfTrackRollers,
          this.chainInsideSpread,
          this.chainOutsideSpread,
          this.chainAutoID
        )
          .subscribe(result => {
            this.response = result
            if (this.response <= 0) {
              this._notify.error(this.response.Message);
            }
            else {
              this.chainAutoID = this.response;
              this.loadChainInfo(this.model_auto);
              this._notify.success('Saved', 'Chain data saved successfully');
              this.isUpdating = true;
            }

          })
      } else {
        this._notify.warn("Please enter number of links.")
      }
    }
    else {
      this._notify.warn("Please enter chain description.")
    }
  }
  dataSourceChain = new MatTableDataSource<ChainInfoModel>([]);
  chainDataLoading: boolean = false;
  hasChainData: boolean=false

  loadChainInfo(model: number) {
    this.chainDataLoading = true;
    this._modelService.GetChainInfo(model).subscribe(result => {
      if (result != null) {

        this.dataSourceChain.data = result;
        
        if(this.dataSourceChain.data.length>0){
          this.hasChainData=true;
          this.chainCreateSection=true;
          this.showTableChainView=true;
        }else{
          this.chainCreateSection=false;
        }
        this.chainDataLoading=true;
      }
      this.chainDataLoading = false;
    })
  }
  isUpdating: boolean;
  chainAutoID: number;

  selectRowChain(row) {
    this.selectRowChain1 = row;
    this.isUpdating = true;
    this.chainDescription = row.Description;
    this.serialNumberstart = row.ModelSerialNumberStart;
    this.serialNumberEnd = row.ModelSerialNumberEnd;
    this.noOfLinks = row.NumberOfLinks;
    this.numberOfIdlers = row.NumberOfIdlers;
    this.numberOfCarrierRollers = row.NumberOfCarrierRollers;
    this.numberOfTrackRollers = row.NumberOfTrackRollers;
    this.pitch = row.Pitch;
    this.boltHoleDiameter = row.BoltHoleDiameter;
    this.linkHeight = row.LinkHeight;
    this.bushingOD = row.BushingOD;
    this.chainInsideSpread = row.ChainInsideSpread;
    this.chainOutsideSpread = row.ChainOutsideSpread;
    this.chainAutoID = row.ChainAutoId;
    this.loadSproketHardwareData();
    this.loadComponentInfo();

  }
  
  ResetChainFileds() {
    this.chainCreateSection=true;
    this.isUpdating = false;
    this.chainDescription = "";
    this.serialNumberstart = null;
    this.serialNumberEnd = null;
    this.noOfLinks = null;
    this.numberOfIdlers = null;
    this.numberOfCarrierRollers = null;
    this.numberOfTrackRollers = null;
    this.pitch = null;
    this.boltHoleDiameter = null;
    this.linkHeight = null;
    this.bushingOD = null;
    this.chainInsideSpread = null;
    this.chainOutsideSpread = null;
    this.chainAutoID = null;
    this.casePartnumber="";
    this.bercoPartNumber="";
    this.chainHardwareDescription="";
    this.quantity=null;
    this.partLineId=null;
    this.cost=null;
    this.newRow=false;
   // this.showTableChainView=false;
    this.showTableCOmponentView=false;
  }
  
  isUpdatingHardware: boolean
 
  update_Hardware() {
    if(this.chainHardwareDescription.trim().length!=0){
      if(this.quantity.toString().trim().length!=0){
        this._componentService.updateSproketHardware(
          null,
          this.casePartnumber,
          this.bercoPartNumber.toString(),
          this.chainHardwareDescription,
          this.quantity,
          this.partLineId,
          this.chainAutoID,
          this.cost,0).subscribe(result => {
            this.isUpdatingHardware = true;
            this.loadSproketHardwareData();
            this._notify.success('Saved', 'Data saved successfully');
          });
      }else{
        this._notify.success('Info', 'Quantity field is required.');
      }
    }else{
      this._notify.success('Info', 'Description field is required.');
    }
   
  }
  updateComponentSproket:UpdateComponentSproket;
  
  loadSproketHardwareData() {
    this._componentService.GetSproketData(0,this.chainAutoID).subscribe(result => {
      this.updateComponentSproket=result;
      this.chainHardwareDescription= this.updateComponentSproket.Description;
      this.bercoPartNumber= this.updateComponentSproket.BercoPartNumberSproket;
      this.quantity= this.updateComponentSproket.Quantity;
      this.casePartnumber= this.updateComponentSproket.CasePartNumberSproket;
      this.cost=this.updateComponentSproket.Cost;
      this.partLineId=this.updateComponentSproket.PartLineId;
    });
  }

  ChainAttachDeattach(event:any,compartMapping:number, chainMapping:number){
    let Isactive=0;
   if(event.checked){
    Isactive=1;
   }else{
    Isactive=0;
   }

   this._componentService.UpdateCompartModelChain(compartMapping,this.chainAutoID,chainMapping,Isactive).subscribe(result => {
      this.isUpdatingHardware = true;
      this._notify.success('Saved', 'Data updated successfully');
    });
  }

}


